import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 10px 0px;\n  * input {\n    width: 100%;\n  }\n  > div > div {\n    width: auto;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from '../../utils/styling/styled-components';
import { TextInputV3 } from '../TextInputsV3/TextInputV3';
var StyledContainer = styled.div(_templateObject());
/* This wrapper component is used to conform FormBuilderV3's props with TextInputV3 */

var TextInputV3CompatibilityWrapper = function TextInputV3CompatibilityWrapper(_ref) {
  var values = _ref.values,
      value = _ref.value,
      name = _ref.name,
      id = _ref.id,
      helperText = _ref.helperText,
      className = _ref.className,
      testId = _ref.testId,
      error = _ref.error,
      errorText = _ref.errorText,
      label = _ref.label,
      labelHidden = _ref.labelHidden,
      labelIcon = _ref.labelIcon,
      handleChange = _ref.handleChange,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      locked = _ref.locked,
      props = _objectWithoutProperties(_ref, ["values", "value", "name", "id", "helperText", "className", "testId", "error", "errorText", "label", "labelHidden", "labelIcon", "handleChange", "onChange", "disabled", "locked"]);

  return /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(TextInputV3, {
    helperText: helperText,
    className: className,
    testId: testId,
    error: error,
    errorText: errorText,
    label: {
      hidden: labelHidden,
      value: label,
      icon: labelIcon
    },
    inputProps: _objectSpread({
      value: value ? value : values[name],
      name: name,
      id: id ? id : name,
      onChange: onChange ? onChange : handleChange,
      disabled: locked ? locked : disabled
    }, props)
  }));
};

export { TextInputV3CompatibilityWrapper };